/* AZP-7099 — FAQ table of contents: scrolls to a topic and highlights the topic in view. */
(function () {
  'use strict';

  // Gap kept between a topic (or the sticky table of contents) and the top of the viewport.
  var GAP = 24;
  // A topic counts as current once its heading passes this line, below the visible header.
  var ACTIVE_OFFSET = 120;

  function getHeader() {
    return document.querySelector('.section-header');
  }

  // sticky-header.js reveals the header on scroll up and hides it on scroll down.
  function isStickyEnabled() {
    var stickyHeader = document.querySelector('sticky-header');
    return !!stickyHeader && stickyHeader.getAttribute('disabled') !== 'true';
  }

  function isHeaderOverlaying(header) {
    var classes = header.classList;
    var sticky = classes.contains('section-header-sticky') || classes.contains('section-header-sticky-always');
    var hidden = classes.contains('section-header-hidden') && !classes.contains('menu-open');
    return sticky && !hidden;
  }

  function headerOffset() {
    var header = getHeader();
    return header && isHeaderOverlaying(header) ? header.offsetHeight : 0;
  }

  // Exposes the height of the revealed header as --bs-faq-header-offset, so the sticky
  // table of contents and the topic anchors move down with it instead of hiding under it.
  function syncHeaderOffset() {
    document.documentElement.style.setProperty('--bs-faq-header-offset', headerOffset() + 'px');
  }

  function watchHeader() {
    var header = getHeader();
    if (!header || header.dataset.faqHeaderWatched) return;
    header.dataset.faqHeaderWatched = 'true';

    new MutationObserver(syncHeaderOffset).observe(header, { attributes: true, attributeFilter: ['class'] });
    if ('ResizeObserver' in window) new ResizeObserver(syncHeaderOffset).observe(header);
    syncHeaderOffset();
  }

  function initFaqToc(nav) {
    if (nav.dataset.faqTocReady) return;
    nav.dataset.faqTocReady = 'true';

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-faq-toc-link]'));
    var items = links
      .map(function (link) {
        return { link: link, topic: document.getElementById(decodeURIComponent(link.hash.slice(1))) };
      })
      .filter(function (item) {
        return item.topic;
      });
    if (!items.length) return;

    function setActive(activeItem) {
      items.forEach(function (item) {
        var isActive = item === activeItem;
        item.link.classList.toggle('is-active', isActive);
        if (isActive) {
          item.link.setAttribute('aria-current', 'true');
        } else {
          item.link.removeAttribute('aria-current');
        }
      });
    }

    function update() {
      var line = headerOffset() + ACTIVE_OFFSET;
      var current = items[0];
      items.forEach(function (item) {
        if (item.topic.getBoundingClientRect().top <= line) current = item;
      });
      setActive(current);
    }

    items.forEach(function (item) {
      item.link.addEventListener('click', function (event) {
        event.preventDefault();

        var targetTop = item.topic.getBoundingClientRect().top + window.pageYOffset;
        // Scrolling up reveals the sticky header, scrolling down hides it: leave room for it
        // only when it will be on screen once the scroll ends.
        var header = getHeader();
        var headerSpace = targetTop < window.pageYOffset && header && isStickyEnabled() ? header.offsetHeight : 0;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: targetTop - headerSpace - GAP, behavior: reduceMotion ? 'auto' : 'smooth' });
        history.replaceState(null, '', item.link.hash);
        setActive(item);
      });
    });

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      },
      { passive: true }
    );

    update();
  }

  function initAll() {
    watchHeader();
    document.querySelectorAll('[data-faq-toc]').forEach(initFaqToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
